module.exports = __webpack_public_path__ + "static/img/glove_corrida.e5e07a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_corrida.png
// module id = yDvF
// module chunks = 0